import React, { useState } from 'react';
import './index.css';
import InputSection from './components/InputSection';
import OptionsSection from './components/OptionsSection';
import ResultSection from './components/ResultSection';
import { transformByUrl, transformByText } from './api/client';

function App() {
  // === 상태 관리 ===
  const [inputMode, setInputMode] = useState('url');          // 'url' | 'text'
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [bodyText, setBodyText] = useState('');
  const [transformMode, setTransformMode] = useState('easy'); // 'easy'|'story'|'debate'|'level'
  const [difficulty, setDifficulty] = useState('adult');
  const [protectedFacts, setProtectedFacts] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [originalText, setOriginalText] = useState('');

  // === 변환 실행 ===
  const handleTransform = async () => {
    setLoading(true);
    setError('');
    setResult(null);

    try {
      const facts = protectedFacts
        .split('\n')
        .map(f => f.trim())
        .filter(f => f.length > 0);

      let response;

      if (inputMode === 'url') {
        if (!url.trim()) {
          setError('기사 URL을 입력해주세요.');
          setLoading(false);
          return;
        }
        response = await transformByUrl({
          url: url.trim(),
          mode: transformMode,
          protected_facts: facts.length > 0 ? facts : null,
          difficulty: transformMode === 'level' ? difficulty : null,
        });
      } else {
        if (!bodyText.trim()) {
          setError('기사 본문을 입력해주세요.');
          setLoading(false);
          return;
        }
        response = await transformByText({
          title: title.trim() || '제목 없음',
          body: bodyText.trim(),
          mode: transformMode,
          protected_facts: facts.length > 0 ? facts : null,
          difficulty: transformMode === 'level' ? difficulty : null,
        });
        setOriginalText(bodyText.trim());
      }

      if (response.success) {
        setResult(response);
        if (inputMode === 'url') {
          setOriginalText(response.original_title || '');
        }
      } else {
        setError(response.error_message || '변환에 실패했습니다.');
      }
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        err.message ||
        '서버와 통신할 수 없습니다. 백엔드 서버가 실행 중인지 확인해주세요.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      {/* 헤더 */}
      <header className="app-header">
        <h1>매경 <span>스토리</span></h1>
        <p>Claude AI 기반 뉴스 콘텐츠 맞춤형 재가공 서비스</p>
      </header>

      {/* 입력 영역 */}
      <InputSection
        inputMode={inputMode}
        setInputMode={setInputMode}
        url={url}
        setUrl={setUrl}
        title={title}
        setTitle={setTitle}
        bodyText={bodyText}
        setBodyText={setBodyText}
      />

      {/* 옵션 영역 */}
      <OptionsSection
        transformMode={transformMode}
        setTransformMode={setTransformMode}
        difficulty={difficulty}
        setDifficulty={setDifficulty}
        protectedFacts={protectedFacts}
        setProtectedFacts={setProtectedFacts}
      />

      {/* 변환 버튼 */}
      <button
        className={`transform-btn ${loading ? 'loading' : ''}`}
        onClick={handleTransform}
        disabled={loading}
      >
        {loading ? '변환 중...' : 'AI로 기사 변환하기'}
      </button>

      {/* 에러 메시지 */}
      {error && <div className="error-message">{error}</div>}

      {/* 로딩 */}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Claude AI가 기사를 변환하고 있습니다...</p>
          <p className="loading-sub">
            {transformMode === 'story' && '두 등장인물의 이야기를 구성하고 있어요'}
            {transformMode === 'easy' && '어려운 경제 용어를 쉽게 풀어쓰고 있어요'}
            {transformMode === 'debate' && '찬성과 반대 논거를 균형있게 정리하고 있어요'}
            {transformMode === 'level' && '선택하신 난이도에 맞게 기사를 재구성하고 있어요'}
          </p>
        </div>
      )}

      {/* 결과 영역 */}
      {result && (
        <ResultSection
          result={result}
          mode={transformMode}
          originalText={originalText}
        />
      )}
    </div>
  );
}

export default App;
